import { ready } from '~/core';
import { addEvents } from '~/utils';

ready('slider_hero', '.sliderHero', slider => {
	const parents = [
		...slider.querySelectorAll('.sliderHero-titles, .sliderHero-contents, .sliderHero-actions'),
	];
	const contents = [
		...slider.querySelectorAll(
			'.sliderHero-title, .sliderHero-copy, .sliderHero-btns, .sliderHero-figure'
		),
	];
	const navs = [...slider.querySelectorAll('.sliderHero-nav--prev, .sliderHero-nav--next')];
	const navCount = slider.querySelector('.sliderHero-nav--count span:nth-child(1)');
	const navTotal = slider.querySelector('.sliderHero-nav--count span:nth-child(2)');

	const total = slider.querySelectorAll('.sliderHero-title').length;
	let current = 1;

	const navigate = e => {
		let dir = e.target.closest('.sliderHero-nav').classList.contains('sliderHero-nav--prev')
			? -1
			: 1;

		current += dir;

		if (current < 1) current = total;
		else if (current > total) current = 1;

		navCount.textContent = current;

		contents.forEach(item => {
			item.start = {};
			item.end = {};
			item.delta = {};

			item.start.top = item.getBoundingClientRect().top;
			item.start.left = item.getBoundingClientRect().left;
		});

		parents.forEach(item => {
			item.start = item.offsetHeight;
		});

		contents.forEach(item => {
			item.classList.remove('is-active');
			if (item.matches(`:nth-child(${current})`)) {
				item.classList.add('is-active');
			}
		});

		contents.forEach(item => {
			item.end.top = item.getBoundingClientRect().top;
			item.end.left = item.getBoundingClientRect().left;

			item.delta.top = item.start.top - item.end.top;
			item.delta.left = item.start.left - item.end.left;
		});

		parents.forEach(item => {
			item.end = item.offsetHeight;
		});

		parents.forEach(item => {
			item.animate([{ height: `${item.start}px` }, { height: `${item.end}px` }], {
				duration: 500,
				easing: 'ease',
			})
		});

		contents.forEach(item => {
			if(!item.classList.contains("sliderHero-figure")){
        item.animate(
          [
            {
              opacity: item.classList.contains('is-active') ? 0 : 1,
              visibility: item.classList.contains('is-active') ? 'hidden' : 'visible',
              transformOrigin: 'top left',
              transform: `translate(${item.delta.left}px, ${item.delta.top}px)`,
            },
            {
              opacity: item.classList.contains('is-active') ? 1 : 0,
              visibility: item.classList.contains('is-active') ? 'visible' : 'hidden',
              transformOrigin: 'top left',
              transform: `none`,
            },
          ],
          {
            duration: 500,
            easing: 'ease',
          }
        );
      }
		});
	};

	const prepare = () => {
		contents.forEach(item => {
			if (item.matches(`:nth-child(1)`)) {
				item.classList.add('is-active');
			}
		});

		navCount.textContent = current;
		navTotal.textContent = total;

		addEvents(navs, 'click.stop enter.stop', navigate);
	};

	prepare();
});
